import Swiper from 'swiper/bundle';


const ht1Slider = new Swiper('.js-ht1-slider', {
    loop: true,
    autoplay: {
        delay: 7000, // Change slide every 3 seconds
        disableOnInteraction: false,
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    slidesPerView: 'auto',
    spaceBetween: 1,
    breakpoints: {
        1: {
            slidesPerView: 'auto',
        },
    },
    navigation: {
        nextEl: '.js-ht1-next',
        prevEl: '.js-ht1-prev',
    },
});

dl.log(ht1Slider.slides.length);
$('.js-ht1-counter').html(`${String(ht1Slider.realIndex + 1).padStart(2, '0')} / ${String(ht1Slider.slides.length  - ht1Slider.loopedSlides * 2).padStart(2, '0')}`);

ht1Slider.on('slideChange', function () {
    $('.js-ht1-counter').html(`${String(ht1Slider.realIndex + 1).padStart(2, '0')} / ${String(ht1Slider.slides.length  - ht1Slider.loopedSlides * 2).padStart(2, '0')}`);
});

const ht1ProgressBar = document.querySelector('.js-ht1-progress-line');

function updateProgressBar() {
    if (ht1ProgressBar) {
        ht1ProgressBar.style.transition = 'none';
        ht1ProgressBar.style.width = '0%';
        setTimeout(() => {
            ht1ProgressBar.style.transition = 'width 7s linear';
            ht1ProgressBar.style.width = '100%';
        }, 50);
    } else {
        console.warn('Progress bar element not found: .js-ht1-progress-line');
    }
}

updateProgressBar();

ht1Slider.on('slideChange', function () {
    updateProgressBar();
});

ht1Slider.on('navigationNext', function () {
    updateProgressBar();
});

ht1Slider.on('navigationPrev', function () {
    updateProgressBar();
});

dl.log(ht1Slider);


const cfSlider = new Swiper('.js-cf-slider', {
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 20,
    breakpoints: {
        640: {
            spaceBetween: 42,
        },
    },
    scrollbar: {
        el: '.js-cf-scrollbar',
        draggable: true,
        dragSize: 300, // Adjust the width of the scrollbar here
    },
    navigation: {
        nextEl: '.js-cf-next',
        prevEl: '.js-cf-prev',
    },
});

dl.log(cfSlider);
